import { Injector } from "@angular/core";
import moment from 'moment';
import { KpiService } from "../../../../dashboardCommon/services/kpiService";
import { DateRange } from "./dateRange";

export class Range {
    public begin: string;
    public end: string;

    constructor(begin: string, end: string) {
        this.begin = begin;
        this.end = end;
    }
}

export abstract class OrdersKpiService<T> extends KpiService<T> {
    constructor(injector: Injector) {
        super(injector);
    }

    protected getDateRange(range: DateRange): Range {
        switch (range) {
            case DateRange.Past: return this.getPastDates();
            case DateRange.Inmediate: return this.getInmediateDates();
            default: throw new Error("Invalid date range");
        }
    }

    private getPastDates(): Range {
        const minDate: string = "20170918";
        let end = moment().subtract(1, 'day');
        return new Range(
            minDate,
            "{0}{1}{2}".format(String(end.year()).padStart(4, "0"), String(end.month() + 1).padStart(2, "0"), String(end.date()).padStart(2, "0"))
        );
    }

    private getInmediateDates(): Range {
        let begin = moment();
        var end = moment().add(5,'years');

        return new Range(
            "{0}{1}{2}".format(String(begin.year()).padStart(4, "0"), String(begin.month() + 1).padStart(2, "0"), String(begin.date()).padStart(2, "0")),
            "{0}{1}{2}".format(String(end.year()).padStart(4, "0"), String(end.month() + 1).padStart(2, "0"), String(end.date()).padStart(2, "0"))
        );
    }
}
